<template lang="pug">
OrderActionModal(v-if="item" :show="show" max-width="min(100vw - 2rem, 30rem)" @close="onClose")
  template(slot="header")
    span.change-size-modal__title.uppercase Cambiar talla · {{ item.product }}

  .change-size-modal
    .change-size-modal__product-row
      InventoryProduct(
        :reference="item.product"
        :size="item.fromSize"
        :quantity="1"
        :brand="item.brand"
        :folder="item.folder"
        :subfolder="item.subfolder"
        :image="item.image"
      )

    shLoader(:show="loading")

    .change-size-modal__section(v-if="!loading && availableSizes.length")
      .change-size-modal__title Talla nueva
      .change-size-modal__sizes
        button.change-size-modal__size(
          v-for="sizeOption in availableSizes"
          :key="sizeOption.size"
          type="button"
          :class="{ 'is-selected': selectedSize === sizeOption.size }"
          :disabled="busy"
          @click="selectedSize = sizeOption.size"
        )
          span.uppercase {{ sizeOption.size }}
          span.change-size-modal__size-qty {{ sizeOption.quantityAvailable }}

    p.change-size-modal__empty(v-if="!loading && !availableSizes.length") No hay tallas disponibles para cambiar.

    .change-size-modal__section(v-if="selectedSize && needsReturnTier")
      .change-size-modal__title Devolver a:
      .change-size-modal__tiers
        button.change-size-modal__tier(
          type="button"
          :class="{ 'is-selected': selectedReturnTier === baseTier }"
          :disabled="busy"
          @click="selectedReturnTier = baseTier"
        ) {{ baseTier }}
        button.change-size-modal__tier(
          v-if="pickedFromTier && pickedFromTier !== baseTier"
          type="button"
          :class="{ 'is-selected': selectedReturnTier === pickedFromTier }"
          :disabled="busy"
          @click="selectedReturnTier = pickedFromTier"
        ) {{ pickedFromTier }}

    .change-size-modal__actions(v-if="canConfirm")
      shActionButton(
        :action="confirmChange"
        text="Confirmar cambio"
        textRunning="Solicitando cambio"
        :normalColor="true"
      )
</template>

<script>
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'
import InventoryProduct from '@/components/pages/inventory/edit/Product.vue'
import shLoader from '@/components/layout/Loader'
import shActionButton from '@/components/elements/ActionButton'
import { getBaseTierByBrand } from '@/helpers/tier'

export default {
  name: 'ChangeSizeModal',

  components: {
    OrderActionModal,
    InventoryProduct,
    shLoader,
    shActionButton
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    order: {
      type: String,
      default: ''
    },
    pickedFromTier: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: false,
      availableSizes: [],
      selectedSize: '',
      selectedReturnTier: ''
    }
  },

  computed: {
    baseTier () {
      return getBaseTierByBrand(this.item && this.item.brand)
    },

    needsReturnTier () {
      return !!this.pickedFromTier
    },

    canConfirm () {
      if (!this.selectedSize) return false
      if (this.needsReturnTier) return !!this.selectedReturnTier
      return true
    }
  },

  watch: {
    show (visible) {
      if (visible) {
        this.resetState()
        this.fetchAvailableSizes()
      }
    }
  },

  methods: {
    resetState () {
      this.availableSizes = []
      this.selectedSize = ''
      this.selectedReturnTier = this.pickedFromTier || this.baseTier
    },

    onClose () {
      if (this.busy) return
      this.$emit('close')
    },

    async fetchAvailableSizes () {
      if (!this.item || !this.order) return

      this.loading = true

      try {
        const response = await gql.query(
          gqlOrder.GET_AVAILABLE_SIZES_FOR_CHANGE,
          {
            order: this.order,
            product: this.item.product,
            size: this.item.fromSize
          },
          false,
          true,
          true
        )

        this.availableSizes = (response &&
          response.data &&
          response.data.getAvailableSizesForChange) || []

        if (this.pickedFromTier) {
          this.selectedReturnTier = this.pickedFromTier
        }
      } finally {
        this.loading = false
      }
    },

    async confirmChange () {
      if (!this.canConfirm) return

      this.$emit('confirm', {
        to: this.selectedSize,
        returnTier: this.needsReturnTier ? this.selectedReturnTier : null
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.change-size-modal
  padding 0 1.5rem 1.5rem
  overflow-y auto
  max-height calc(100vh - 8rem)

.change-size-modal__title
  font-size 1rem
  font-weight 600

.change-size-modal__product-row
  margin-bottom 1.25rem

.change-size-modal__section
  margin-top 1.25rem

.change-size-modal__section > .change-size-modal__title
  text-transform uppercase
  font-size .85rem
  color var(--color-placeholder)
  margin-bottom .65rem

.change-size-modal__sizes,
.change-size-modal__tiers
  display flex
  flex-wrap wrap
  gap .5rem

.change-size-modal__size,
.change-size-modal__tier
  font-family inherit
  font-size 1em
  font-weight 600
  text-transform uppercase
  padding .45em .75em
  background-color #e9e9e7
  border 2px solid transparent
  cursor pointer

  &.is-selected
    border-color var(--color-font-principal)

  &:disabled
    opacity .35
    cursor not-allowed

.change-size-modal__size
  display inline-flex
  align-items center
  gap .5rem

.change-size-modal__size-qty
  font-size .85em
  opacity .65

.change-size-modal__empty
  margin 1rem 0 0
  opacity .7

.change-size-modal__actions
  margin-top 1.5rem
</style>



// WEBPACK FOOTER //
// src/components/pages/order/ChangeSizeModal.vue